// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"508":"e4eaab8f","576":"6574761a","897":"d032e5b0"}[chunkId] + ".chunk.css";
};